import PageShell from "./PageShell";
import Seasonal from "@/components/site/Seasonal";
import SeasonalMenus from "@/components/site/SeasonalMenus";

export default function SeasonsPage() {
  return (
    <PageShell testId="page-seasons">
      <Seasonal />
      <SeasonalMenus />
    </PageShell>
  );
}
